import { nextDate } from "./nextDate";
import { refreshCurrentDate } from "../cpcoc/currentDate";
export function startTimer(countdown, // TODO: Can we replace false with optional?
startTime, repeat, // TODO: Can we replace false with optional?
serviceEvent, // TODO: Can we replace false with optional?
callback, prevProgress) {
    const now = refreshCurrentDate();
    const nowValue = now.valueOf();
    let offsetStartTime = startTime.valueOf() + 1000;
    const offsetCountdown = (countdown ? countdown : 0) + 1000;
    let timerProgress = Math.trunc((offsetStartTime - nowValue) / 1000);
    let timerStartTime = offsetStartTime - offsetCountdown;
    if (countdown === 0 ||
        (nowValue >= timerStartTime && nowValue <= offsetStartTime)) {
        // if right now is between the countdown and event start times
        if (timerProgress !== prevProgress && typeof callback === "function") {
            let event = "updated";
            if (!countdown) {
                event = "started-ended"; // what is this use case again?
            }
            else if (prevProgress === undefined) {
                event = "started";
            }
            else if (timerProgress === 0) {
                event = "ended";
            }
            callback({
                timerProgress,
                timerEvent: event, // basically shows and updates the countdown
                serviceEvent,
                // countdown,
                // startTime,
                // now,
            });
        }
        if (!countdown) {
            // start over
            countdown = false;
            startTime = nextDate(repeat, startTime.getDay(), startTime.getHours() + ":" + startTime.getMinutes());
            timerProgress = undefined;
        }
        self.requestAnimationFrame(() => startTimer(countdown, startTime, repeat, serviceEvent, callback, timerProgress));
    }
    else if (repeat || (!repeat && nowValue < offsetStartTime)) {
        // ELSE IF we want to repeat
        // OR our event hasn't started yet
        startTime =
            nowValue < offsetStartTime
                ? startTime
                : nextDate(repeat, startTime.getDay(), startTime.getHours() + ":" + startTime.getMinutes());
        offsetStartTime = startTime.valueOf() + 1000;
        timerStartTime = offsetStartTime - offsetCountdown;
        // TODO: Need to check to make sure callback is available and a function?
        // callback({
        //     timerProgress,
        //     timerEvent: "initialized", // basically hides the countdown
        //     serviceEvent,
        //     // countdown,
        //     // startTime,
        //     // now,
        // });
        // TODO: Can we only have one or two active countdown timeouts at once?
        setTimeout(() => {
            // get difference and set timeout
            // let's wait to call startCountdown again until the next countdown
            startTimer(countdown || 0, startTime, repeat, serviceEvent, callback);
        }, timerStartTime - nowValue);
    }
}
